var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPensionPlanBalanced = function SvgPensionPlanBalanced(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 813,
    height: 152,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pension-plan-balanced_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#320327",
    d: "M0 10C0 4.477 4.477 0 10 0h793c5.523 0 10 4.477 10 10v132c0 5.523-4.477 10-10 10H10c-5.523 0-10-4.477-10-10z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 445.5,
    cy: 75.5,
    fill: "#AD9AA9",
    rx: 102.5,
    ry: 103.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.5,
    cy: 75.5,
    fill: "#AD9AA9",
    rx: 102.5,
    ry: 103.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 856,
    cy: 75.5,
    fill: "#AD9AA9",
    rx: 102,
    ry: 103.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 651,
    cy: 75.5,
    fill: "#AD9AA9",
    rx: 103,
    ry: 103.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.5,
    cy: 75.5,
    fill: "#AD9AA9",
    rx: 102.5,
    ry: 103.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pension-plan-balanced_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 10C0 4.477 4.477 0 10 0h793c5.523 0 10 4.477 10 10v132c0 5.523-4.477 10-10 10H10c-5.523 0-10-4.477-10-10z"
  })))));
};
export { SvgPensionPlanBalanced as ReactComponent };
export default __webpack_public_path__ + "images/pension-plan-balanced.svg";